import React from 'react';
import { Link } from 'react-router-dom';

const LegalNote = () => {
    return (
        <div
            className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 text-blue-900 dark:text-blue-100 px-6 py-5 rounded-lg mb-8 flex items-start"
            role="alert"
        >
            <span className="material-symbols-outlined text-blue-600 dark:text-blue-400 mr-4 mt-1">info</span>
            <div>
                <h4 className="font-bold mb-3 text-lg">Legal Notice & Important Information</h4>
                <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
                    <li>
                        <strong>Terms of Service:</strong> This service accesses publicly available Reddit content in accordance with{' '}
                        <a href="https://www.redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer" className="font-semibold underline hover:text-blue-700 dark:hover:text-blue-300">
                            Reddit's API Terms of Service
                        </a>. Your use of this tool is subject to both Reddit's and our own terms.
                    </li>
                    <li>
                        <strong>Data Limitations:</strong> AI analysis may contain inaccuracies, misinterpretations, or biases. Verify all findings independently before making business decisions.
                    </li>
                    <li>
                        You're using the free version of WizeHelper, which provides quick insights. Premium features offer enhanced analysis capabilities.
                    </li>
                    <li>
                        <strong>Commercial Use:</strong> If using insights for commercial purposes, ensure compliance with applicable laws and intellectual property rights.
                    </li>
                    <li>
                        Want more? <Link to="/contact-us" className="font-semibold underline hover:text-blue-700 dark:hover:text-blue-300">Contact us</Link> for premium features.
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default LegalNote;
